import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { Calendar } from 'lucide-react';

// Mock data
const monthlySpendingData = [
  { name: 'Jan', total: 120 },
  { name: 'Feb', total: 140 },
  { name: 'Mar', total: 180 },
  { name: 'Apr', total: 190 },
  { name: 'May', total: 170 },
  { name: 'Jun', total: 210 },
];

const upcomingRenewals = [
  { name: "Netflix", date: "Jun 15", amount: 15.99 },
  { name: "Spotify", date: "Jun 22", amount: 9.99 },
  { name: "Adobe Creative Cloud", date: "Jul 01", amount: 52.99 },
];

const OverviewTab = () => {
  return (
    <div className="space-y-6">
      {/* Monthly Spending Chart */}
      <div className="bg-white rounded-lg p-6 shadow-md">
        <h3 className="text-lg font-semibold mb-2">Monthly Spending</h3>
        <p className="text-sm text-gray-500 mb-4">Your subscription expenses over the past 6 months</p>
        <div className="h-[300px] w-full">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={monthlySpendingData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip 
                formatter={(value) => [`$${value}`, 'Total']}
                labelStyle={{ color: '#666' }}
              />
              <Bar dataKey="total" fill="#4F46E5" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* Upcoming Renewals */}
      <div className="grid gap-6 md:grid-cols-2">
        <div className="bg-white rounded-lg p-6 shadow-md">
          <h3 className="text-lg font-semibold mb-4">Upcoming Renewals</h3>
          <ul className="space-y-4">
            {upcomingRenewals.map((sub, index) => (
              <li key={index} className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <Calendar className="h-5 w-5 text-gray-400" />
                  <span className="text-sm font-medium">{sub.name}</span>
                </div>
                <div className="flex items-center space-x-4">
                  <span className="text-sm text-gray-500">{sub.date}</span>
                  <span className="font-semibold">${sub.amount}</span>
                </div>
              </li>
            ))}
          </ul>
        </div>

        {/* Subscription Health */}
        <div className="bg-white rounded-lg p-6 shadow-md">
          <h3 className="text-lg font-semibold mb-4">Subscription Health</h3>
          {[
            { label: "Optimized", value: 80, color: "bg-green-500" },
            { label: "At Risk", value: 15, color: "bg-yellow-500" },
            { label: "Unused", value: 5, color: "bg-red-500" },
          ].map((item, index) => (
            <div key={index} className="mb-2">
              <div className="flex items-center justify-between">
                <span className="text-sm text-gray-500">{item.label}</span>
                <div className="w-1/2">
                  <div className={`h-2 rounded-full ${item.color}`} style={{ width: `${item.value}%` }}></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OverviewTab; 